import { useRouter } from "next/router"
import React from "react"
import CustomButton from "../../../../ui/atoms/Button"
import Typography from "../../../../ui/atoms/Typography"
import { CustomBox } from "../../../../ui/spacings"

const EmptyWishlist = () => {
  const router = useRouter()
  return (
    <CustomBox flex="row" justifyContent="center" alignItems="center" w100>
      <CustomBox textCenter>
        <Typography variant="body1">La tua wishlist è vuota</Typography>
        <CustomBox my={3}>
          <CustomButton size="small" fullWidth onClick={() => router.push("/")}>
            Vai allo shopping
          </CustomButton>
        </CustomBox>
      </CustomBox>
    </CustomBox>
  )
}

export default EmptyWishlist
